import React from 'react';

export default function Skeleton() {
  return (
    <section className="message">
      <section className="msg-wrapper animate-pulse">
        <section className="profile-pic">
          <section className="w-12 h-12 bg-gray-200 rounded-full" />
        </section>
        <section className="profile-details mb-4">
          <section className="w-16 h-3 bg-gray-200 rounded mr-2" />
          <section className="w-10 h-3 bg-gray-200 rounded" />
        </section>
        <section className="msg-content">
          <section className="text-container space-y-4">
            <section className="msg-content space-y-2">
              <section className="w-full h-3 bg-gray-200 rounded" />
              <section className="w-20 h-3 bg-gray-200 rounded" />
            </section>
          </section>
          <section className="flex justify-stretch">
            <section className="w-full h-40 bg-gray-200 rounded-lg" />
          </section>
        </section>
      </section>
    </section>
  );
}
